import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class AdminOrderPartialRefundItemRequest {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly refundPrice!: string;

  public constructor(
    private readonly data: {
      id: Guid;
      refundPrice: string;
    },
  ) {
    this.id = this.data.id;
    this.refundPrice = this.data.refundPrice;
  }
}

@jsonObject
export class AdminOrderPartialRefundShipmentRequest {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly refundPrice!: string;

  public constructor(
    private readonly data: {
      id: Guid;
      refundPrice: string;
    },
  ) {
    this.id = this.data.id;
    this.refundPrice = this.data.refundPrice;
  }
}

@jsonObject
export class AdminOrderPartialRefundRequest {
  @jsonArrayMember(AdminOrderPartialRefundItemRequest)
  public readonly items!: AdminOrderPartialRefundItemRequest[];

  @jsonArrayMember(AdminOrderPartialRefundShipmentRequest)
  public readonly shipments!: AdminOrderPartialRefundShipmentRequest[];

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  public constructor(
    private readonly data: {
      items: Array<{
        id: Guid;
        refundPrice: string;
      }>;
      shipments: Array<{
        id: Guid;
        refundPrice: string;
      }>;
      comment?: Nillable<string>;
    },
  ) {
    this.items = this.data.items.map(
      (item) => new AdminOrderPartialRefundItemRequest(item),
    );
    this.shipments = this.data.shipments.map(
      (shipment) => new AdminOrderPartialRefundShipmentRequest(shipment),
    );
    this.comment = this.data.comment;
  }
}
